import { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store/store';

import MySavedPrescriptions from '@components/pdp-contacts-prescriptions/my-saved-prescriptions/MySavedPrescriptions';
import AddNewPrescription from '@components/pdp-contacts-prescriptions/my-new-prescription/AddNewPrescription';

const LoggedUserPage = () => {
    const mySavedPrescriptions = useSelector(
        (state: RootState) => state.contacts.mySavedPrescriptions
    );
    const getMySavedPrescriptionsRequestStatus = useSelector(
        (state: RootState) => state.contacts.getMySavedPrescriptionsRequestStatus
    );

    const [isNewPrescription, setIsNewPrescription] = useState(false);

    const noPrescriptions =
        getMySavedPrescriptionsRequestStatus === 'SUCCESS' && !mySavedPrescriptions?.length;

    return (
        <div className="presc-tab-selection">
            {!noPrescriptions && (
                <div className="presc-tab-selection-container">
                    <button
                        className={`presc-tab ${!isNewPrescription ? 'active' : ''}`}
                        onClick={() => setIsNewPrescription(false)}
                        data-element-id="Prod_MyPrescriptions"
                        data-analytics_available_call="1"
                    >
                        My prescriptions
                    </button>

                    <button
                        className={`presc-tab ${isNewPrescription ? 'active' : ''}`}
                        onClick={() => setIsNewPrescription(true)}
                        data-element-id="Prod_AddPrescription"
                        data-analytics_available_call="1"
                    >
                        Add new prescription
                    </button>
                </div>
            )}

            {isNewPrescription || noPrescriptions ? (
                <AddNewPrescription showNoPrescriptionsAlert={noPrescriptions} />
            ) : (
                <MySavedPrescriptions />
            )}
        </div>
    );
};

export default LoggedUserPage;
